module.exports = __webpack_public_path__ + "img/history.aa7f2431.png";